<script setup lang="ts">
import { SUPPORT_PHONE } from '@js-app/const/config'

import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
  NavigationMenuTrigger,
  navigationMenuTriggerStyle
} from "@/components/ui/navigation-menu"

const onlineSupportChannels = [
  {
    title: 'Telegram',
    href: 'https://t.me/xpaysupportbot',
    icon: `<svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 8.44415C0 3.78057 3.78057 0 8.44415 0H17.5638C22.2274 0 26.008 3.78057 26.008 8.44415V17.5638C26.008 22.2274 22.2274 26.008 17.5638 26.008H8.44415C3.78057 26.008 0 22.2274 0 17.5638V8.44415Z" fill="#30A8DB"/><path d="M10.9114 14.688L15.17 17.7739C15.6539 18.0332 16.0059 17.9036 16.1291 17.3331L17.8624 9.31146C18.0384 8.6113 17.5897 8.30012 17.1233 8.50757L6.95189 12.3628C6.25678 12.6394 6.26558 13.0197 6.8287 13.184L9.44196 13.9878L15.4868 10.245C15.7683 10.0721 16.0323 10.1672 15.8211 10.3574L10.9114 14.688Z" fill="url(#telegram-gradient)"/><defs><linearGradient id="telegram-gradient" x1="13.4622" y1="12.9035" x2="15.6062" y2="16.3953" gradientUnits="userSpaceOnUse"><stop stop-color="#EFF7FC"/><stop offset="1" stop-color="white"/></linearGradient></defs></svg>`,
  },
  {
    title: 'Facebook Messenger',
    href: 'https://m.me/121860965200057',
    icon: `<svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.0078125 8.44415C0.0078125 3.78057 3.78839 0 8.45196 0H17.5716C22.2352 0 26.0158 3.78057 26.0158 8.44415V17.5638C26.0158 22.2274 22.2352 26.008 17.5716 26.008H8.45196C3.78839 26.008 0.0078125 22.2274 0.0078125 17.5638V8.44415Z" fill="#2196F3"/><path d="M11.5955 9.79538L5.07471 16.5507L11.1125 13.5393L14.1716 16.5507L20.6119 9.79538L14.8157 12.8882L11.5955 9.79538Z" fill="white"/></svg>`,
  },
  {
    title: 'Email',
    href: 'mailto:info@xpay.com.ua',
    icon: `<svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.015625 8.44415C0.015625 3.78057 3.7962 0 8.45977 0H17.5794C22.243 0 26.0236 3.78057 26.0236 8.44415V17.5638C26.0236 22.2274 22.243 26.008 17.5794 26.008H8.45977C3.7962 26.008 0.015625 22.2274 0.015625 17.5638V8.44415Z" fill="#F86185"/><path d="M17 9H9C7.9 9 7 9.9 7 11V16C7 17.1 7.9 18 9 18H17C18.1 18 19 17.1 19 16V11C19 9.9 18.1 9 17 9ZM17.8 11.9L13.85 14.55C13.6 14.7 13.3 14.8 13 14.8C12.7 14.8 12.4 14.7 12.15 14.55L8.2 11.9C8 11.75 7.95 11.45 8.1 11.2C8.25 11 8.55 10.95 8.8 11.1L12.75 13.75C12.9 13.85 13.15 13.85 13.3 13.75L17.25 11.1C17.5 10.95 17.8 11 17.95 11.25C18.05 11.45 18 11.75 17.8 11.9Z" fill="white"/></svg>`,
  },
  {
    title: 'LinkedIn',
    href: 'https://www.linkedin.com/company/1xpay',
    icon: `<svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.0239258 8.44415C0.0239258 3.78057 3.8045 0 8.46807 0H17.5877C22.2513 0 26.0319 3.78057 26.0319 8.44415V17.5638C26.0319 22.2274 22.2513 26.008 17.5877 26.008H8.46807C3.8045 26.008 0.0239258 22.2274 0.0239258 17.5638V8.44415Z" fill="#0077B7"/><path d="M18.2608 16.5506V16.5502H18.2632V13.0817C18.2632 11.3849 17.8979 10.0778 15.9142 10.0778C14.9605 10.0778 14.3206 10.6011 14.0593 11.0972H14.0317V10.2362H12.1509V16.5502H14.1094V13.4237C14.1094 12.6006 14.2654 11.8045 15.2848 11.8045C16.2893 11.8045 16.3043 12.744 16.3043 13.4765V16.5506H18.2608Z" fill="white"/><path d="M8.96143 10.2366H10.9223V16.5507H8.96143V10.2366Z" fill="white"/><path d="M9.94135 7.09314C9.3144 7.09314 8.80566 7.60187 8.80566 8.22882C8.80566 8.85577 9.3144 9.37514 9.94135 9.37514C10.5683 9.37514 11.077 8.85577 11.077 8.22882C11.0766 7.60187 10.5679 7.09314 9.94135 7.09314V7.09314Z" fill="white"/></svg>`,
  },
]
</script>

<template>
  <NavigationMenu>
    <NavigationMenuList>

      <NavigationMenuItem>
        <NavigationMenuLink
            :href="`tel:${SUPPORT_PHONE}`"
            :class="navigationMenuTriggerStyle()"
            class="pr-1"
        >
          <a :href="`tel:${SUPPORT_PHONE}`" class="mr-1">
            {{ SUPPORT_PHONE }}
          </a>
        </NavigationMenuLink>
      </NavigationMenuItem>

      <NavigationMenuItem>
        <NavigationMenuTrigger class="p-2">
        </NavigationMenuTrigger>

        <NavigationMenuContent>
          <ul class="flex w-[150px] justify-between">
            <li v-for="option in onlineSupportChannels" :key="option.title">
              <NavigationMenuLink
                  as-child
                  :href="option.href"
                  target="_blank"
              >
                <a
                    class="block select-none space-y-1 rounded-md p-3 leading-none no-underline outline-none transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground"
                    :title="option.title"
                >
                  <div class="line-clamp-2 leading-snug text-muted-foreground" v-html="option.icon"></div>
                </a>
              </NavigationMenuLink>
            </li>
          </ul>
        </NavigationMenuContent>
      </NavigationMenuItem>

    </NavigationMenuList>
  </NavigationMenu>
</template>

<!--<template>-->
<!--  <NavigationMenu>-->
<!--    <NavigationMenuList>-->

<!--      <NavigationMenuItem>-->

<!--        <NavigationMenuTrigger>-->
<!--          <a :href="`facetime:${SUPPORT_PHONE}`" class="mr-1">-->
<!--            {{ SUPPORT_PHONE }}-->
<!--          </a>-->
<!--        </NavigationMenuTrigger>-->

<!--        <NavigationMenuContent>-->
<!--          <ul class="flex w-[150px] justify-between">-->
<!--            <li v-for="option in onlineSupportChannels" :key="option.title">-->
<!--              <NavigationMenuLink-->
<!--                  as-child-->
<!--                  :href="option.href"-->
<!--                  target="_blank"-->
<!--              >-->
<!--                <a-->
<!--                    class="block select-none space-y-1 rounded-md p-3 leading-none no-underline outline-none transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground"-->
<!--                >-->
<!--                  <div class="line-clamp-2 leading-snug text-muted-foreground" v-html="option.icon"></div>-->
<!--                </a>-->
<!--              </NavigationMenuLink>-->
<!--            </li>-->
<!--          </ul>-->
<!--        </NavigationMenuContent>-->
<!--      </NavigationMenuItem>-->
<!--    </NavigationMenuList>-->
<!--  </NavigationMenu>-->
<!--</template>-->